export const MenuItems = [
    {
        title : "Home",
        url : '/',
        cName : "nav-links"

    },
    {
        title : "About",
        url : '/about',
        cName : "nav-links"

    }
    // changes
    // {
    //     title : "Sign Up",
    //     url : '/signin',
    //     cName : "nav-links-mobile"
    // },
]

